import { getAllKmzsWithFilters } from './get_all_kmz_with_filters.function';
import { getPartnerColor } from './get_color_for_partners.function';
export const updateLayersOfKmzs = async (
  map,
  names,
  currentKmzNetwork,
  kmzPartner,
  filteredKmzDataForDisplayed,
  setFilteredKmzForDisplayed,
  partner
) => {
  try {
    // Fetch data
    let resp = [];

    if (partner || names.length > 0) {
      resp = await getAllKmzsWithFilters('', names, currentKmzNetwork, kmzPartner);
    }

    const newData = resp?.response ?? [];
    filteredKmzDataForDisplayed.forEach((layerId) => {
      if (map.current.getLayer(layerId)) {
        map.current.removeLayer(layerId);
      }
      if (map.current.getSource(layerId)) {
        map.current.removeSource(layerId);
      }
    });

    // Prepare GeoJSON
    // const geoJsonData = {
    //     type: "FeatureCollection",
    //     features: newData?.map_data?.map((item) => ({
    //         type: "Feature",
    //         geometry: {
    //             type: item.geoJson.type,
    //             coordinates: item.geoJson.coordinates, // Use full coordinates array
    //         },
    //         properties: {
    //             id: item.id,
    //             name: item.name,
    //             partner: item.partner,
    //             network: item.network,
    //             uploadedAt: item.uploadedAt,
    //         },
    //     })),
    // };

    const geoJsonData = {
      type: 'FeatureCollection',
      features: newData?.flatMap(
        (file) =>
          file.map_data?.map((item) => ({
            type: 'Feature',
            geometry: {
              type: item.geoJson.type,
              coordinates: item.geoJson.coordinates,
            },
            properties: {
              id: item.id,
              name: item.name,
              partner: file.partner, // from file
              network: file.network, // from file
              uploadedAt: item.uploadedAt,
            },
          })) || []
      ),
    };

    const partnerColorExpression = [
      'match',
      ['get', 'partner'],
      'Zong',
      getPartnerColor('Zong'),
      'zong',
      getPartnerColor('zong'),
      'Jazz',
      getPartnerColor('Jazz'),
      'jazz',
      getPartnerColor('jazz'),
      'telenor',
      getPartnerColor('telenor'),
      'Telenor',
      getPartnerColor('Telenor'),
      'Ufone',
      getPartnerColor('Ufone'),
      'cybernet',
      getPartnerColor('cybernet'),
      'multinet',
      getPartnerColor('multinet'),
      'optix',
      getPartnerColor('optix'),
      'ptcl',
      getPartnerColor('ptcl'),
      'ufone',
      getPartnerColor('ufone'),
      'wateen',
      getPartnerColor('wateen'),
      'nayatel',
      getPartnerColor('nayatel'),
      '#BD1D23', // Default color if no match
    ];
    const sourceId = 'response-source';
    const pointLayerId = 'response-points';
    const lineLayerId = 'response-lines';

    // Add or update source
    if (!map.current.getSource(sourceId)) {
      map.current.addSource(sourceId, {
        type: 'geojson',
        data: geoJsonData,
      });
    } else {
      map.current.getSource(sourceId).setData(geoJsonData);
    }

    // Add Circle Layer for Points
    if (!map.current.getLayer(pointLayerId)) {
      map.current.addLayer({
        id: pointLayerId,
        type: 'circle',
        source: sourceId,
        filter: ['==', ['geometry-type'], 'Point'],
        paint: {
          'circle-radius': 6,
          'circle-color': partnerColorExpression,
          'circle-stroke-width': 1,
          'circle-stroke-color': '#fff',
        },
      });
    }

    // Add Line Layer for LineStrings
    if (!map.current.getLayer(lineLayerId)) {
      map.current.addLayer({
        id: lineLayerId,
        type: 'line',
        source: sourceId,
        filter: ['==', ['geometry-type'], 'LineString'],
        layout: {
          'line-join': 'round',
          'line-cap': 'round',
        },
        paint: {
          'line-color': partnerColorExpression,
          'line-width': 2,
        },
      });
    }

    setFilteredKmzForDisplayed([pointLayerId, lineLayerId]);
  } catch (error) {
    console.error('Error fetching layers:', error);
  }
};
